import React from 'react';
import config from '../../../../config';
import {translate as t} from '../../../../lib/I18n';

export default function STicketLoadingDetails() {
    return (
        <div className="vertical-align-parent load-smartcard-modal__body">
            <div>
                <p className="text-weight--bold margin-bottom--sm">
                    {t('booking.delivery.sticket.modal.body', {
                        brand: t('app.owner.short'),
                    })}
                </p>
                <p>{t('booking.delivery.smartcard.modal.cta')}</p>

                <div className="load-smartcard-modal__app-badges">
                    <a href={config.get('appStoreAppUrl')} target="_blank">
                        <img
                            src="/images/mobile-apps/app-store.png"
                            alt={t('ontrackapp.widget.appstoreButtonAltText')}
                        />
                    </a>
                    <a href={config.get('googlePlayAppUrl')} target="_blank">
                        <img
                            src="/images/mobile-apps/google-play.png"
                            alt={t('ontrackapp.widget.googlePlayButtonAltText')}
                        />
                    </a>
                </div>
            </div>
            <div className="load-smartcard-modal__illustration load-smartcard-modal__illustration--sticket">
                <img
                    src={config.get('loadSTicketIllustration')}
                    alt={t('booking.delivery.loadSmartcardIllustration')}
                />
            </div>
        </div>
    );
}
